<template>
  <Layout>
    <PageHeader :title="'Order Confirmed'" :items="breadcrumbs" />
    <div class="order-confirmation text-center py-5" :style="{ paddingBottom: '64px' }">
      <div v-if="loading" class="py-5">
        <b-spinner variant="primary" />
      </div>
      <div v-else-if="order">
        <div class="confirmation-icon mb-4">
          <i class="bx bx-check-circle text-success" style="font-size: 64px;"></i>
        </div>
        <h1 class="confirmation-title mb-3">Order Confirmed</h1>
        <b-card class="order-summary mx-auto" style="max-width: 400px;">
          <p><strong>Order #{{ order.order_no }}</strong></p>
          <p>{{ order.products ? order.products.length : 0 }} item(s)</p>
          <p class="order-total">R{{ formatPrice(order.order_total) }}</p>
          <hr />
          <p class="text-muted">Estimated ready: ~30 min</p>
          <p class="mt-3"><strong>Show this at collection</strong></p>
        </b-card>
        <div class="mt-4">
          <b-button variant="primary" class="mr-2" @click="$router.push({ name: 'member-shop' })">
            Browse More Products
          </b-button>
          <b-button variant="outline-primary" @click="$router.push({ name: 'member-orders' })">
            View My Orders
          </b-button>
        </div>
      </div>
      <div v-else>
        <p class="text-muted">Order not found.</p>
      </div>
    </div>
    <cart-bottom-nav active-tab="" :cart-count="cartItemCount" @navigate="handleNavigate" />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CartBottomNav from "@/components/member/cartBottomNav";
import { memberOrderingComputed, memberOrderingMethods } from "@/state/helpers";

export default {
  page: { title: "Order Confirmed" },
  components: { Layout, PageHeader, CartBottomNav },
  data() {
    return {
      order: null,
      loading: true,
    };
  },
  computed: {
    ...memberOrderingComputed,
    breadcrumbs() {
      return [{ text: "Order Confirmed", active: true }];
    },
  },
  methods: {
    ...memberOrderingMethods,
    formatPrice(val) {
      return parseFloat(val).toFixed(2);
    },
    handleNavigate(tab) {
      const routes = {
        shop: "member-shop",
        cart: "member-cart",
        orders: "member-orders",
        profile: "member-profile",
      };
      if (routes[tab] && this.$route.name !== routes[tab]) {
        this.$router.push({ name: routes[tab] });
      }
    },
  },
  created() {
    const orderId = this.$route.params.id;
    window.axios
      .get("api/orders/order", { params: { id: orderId } })
      .then((response) => {
        this.order = response.data;
        this.loading = false;
        // Clear cart on confirmation page
        this.$store.commit("memberOrdering/CLEAR_CART");
      })
      .catch(() => {
        this.order = null;
        this.loading = false;
      });
  },
};
</script>

<style scoped lang="scss">
@import "~@/design/tokens/brand";
@import "~@/design/tokens/typography";
@import "~@/design/tokens/surfaces";

.order-confirmation {
  animation: member-fade-in 150ms ease;
}

@keyframes member-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.confirmation-title {
  font-size: 28px;
  font-weight: 700;
}

.order-total {
  font-size: 24px;
  font-weight: 600;
  color: $text-primary;
}

.order-summary {
  background: $surface-card;
}
</style>
